import { render } from "./Footer.vue?vue&type=template&id=9efbc0d4"
const script = {}

import exportComponent from "C:\\__MRYNK\\_2022\\ey-padel-matchmaking-app\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__